import { func, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';

import ContentColumns from '../../components/ContentColumns';
import ControlSteps from '../../components/ControlSteps';

const View2 = (_, { fm, formValues, onChange }) => {
  const followedPlan = path(['rehab4', 'followedPlan'], formValues);

  const controlStepData = {
    currentStatus: path(['rehab3', 'currentStatus'], formValues),
    clearlyWorseStatus: path(['rehab3', 'clearlyWorseStatus'], formValues),
    nearFutureTarget: path(['rehab3', 'nearFutureTarget'], formValues),
    betterStatus: path(['rehab3', 'betterStatus'], formValues),
    clearlyBetterStatus: path(['rehab3', 'clearlyBetterStatus'], formValues),
  };

  const currentStatusSelected = path(['rehab4', 'currentStatusSelected'], formValues);

  const onChangeSelected = name => {
    onChange({ currentStatusSelected: name });
  };

  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fm(`onlineRehabilitation.rehab4.2.header`)}</h2>
            <br />
            <div>{fm(`onlineRehabilitation.rehab4.2.${!followedPlan ? 'textNegative' : 'textPositive'}`)}</div>
            <br />
            <ControlSteps
              steps={controlStepData}
              checkedValue={currentStatusSelected || 'nothingSelected'}
              onCheck={onChangeSelected}
              fm={fm}
            />
          </div>
        }
      />
    </React.Fragment>
  );
};

View2.contextTypes = {
  fm: func,
  formValues: object,
  onChange: func,
};
export default View2;
